import { Link } from "react-router-dom";
import { stories } from "@/mocks/stories";
import { SectionHead, RankCard } from "@/components/feature/cards";

export default function HotRank() {
  const ranked = [...stories]
    .sort((a, b) => Number(b.heat.replace("万", "")) - Number(a.heat.replace("万", "")))
    .slice(0, 6);

  return (
    <section className="container-x py-10 md:py-14">
      <SectionHead
        kicker="实时热度 · 大瓜榜"
        title="今日最热，蹲后续的朋友都在这"
        linkTo="/collection/featured"
        linkLabel="进入盘点合集"
      />
      <div className="grid gap-5 lg:grid-cols-3">
        {/* Featured big block */}
        <div className="rounded-lg border border-background-200 bg-background-100/60 p-5 md:p-6">
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.18em] text-primary-600">
            TOP 1 · 实时热搜
          </p>
          <Link to={`/story/${ranked[0].slug}`} className="group block">
            <div className="relative aspect-[16/10] overflow-hidden rounded-md bg-background-200">
              <img
                src={ranked[0].cover}
                alt={ranked[0].coverAlt}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-2xl">
              {ranked[0].title}
            </h3>
            <p className="mt-2 line-clamp-2 text-sm text-foreground-600">{ranked[0].lead}</p>
            <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-primary-500 px-4 py-1.5 text-xs font-bold text-background-50">
              <i className="ri-fire-fill" /> 热度 {ranked[0].heat} · 围观去
            </p>
          </Link>
        </div>

        {/* Rank list */}
        <div className="flex flex-col gap-1 rounded-lg border border-background-200 bg-background-50 p-3 md:col-span-2 md:p-4">
          {ranked.slice(1).map((s, idx) => (
            <RankCard key={s.slug} story={s} rank={idx + 2} />
          ))}
          <div className="mt-2 border-t border-dashed border-background-300 pt-3">
            <Link
              to="/collection/featured"
              className="inline-flex items-center gap-1 px-2 text-sm font-bold text-primary-600 transition-colors hover:text-primary-700"
            >
              查看完整实时吃瓜合集
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}